.tableMinWidth {
	width: 100% !important;
}

.bold {
	font-weight: bold !important;
}

.tableBackground {
	background-color: var(--title-background) !important;
}

.textDecorationLineThrough {
	text-decoration: line-through;
}
